import { render, staticRenderFns } from "./BillingInformationSettingsTab.vue?vue&type=template&id=180cfc56&scoped=true"
import script from "./BillingInformationSettingsTab.vue?vue&type=script&lang=js"
export * from "./BillingInformationSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180cfc56",
  null
  
)

export default component.exports